import { Icon as _Icon, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivLogoBox = styled.div`
  padding: 10px 15px;
  grid-area: logo;

  ${mq.sp} {
    padding: 0px 5px;
  }
`;
export const Icon = styled(_Icon)`
  justify-content: flex-start;

  svg {
    height: 28px;
    width: auto;
    max-width: 100%;

    ${mq.sp} {
      height: 24px;
    }
  }
`;
